import { Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Table, Thead, Tbody, Tr, Th, Td, Box, ModalCloseButton } from '@chakra-ui/react';

interface PageInfoProps {
    isOpen: boolean;
    onClose: () => void;
}

const columnInfo = [
    { key: "EmpCode", label: "Employee Code (Unique Employee Identifier)" },
    { key: "Employee Name(Dep)", label: "Employee Name (Department)" },
    { key: "Basic", label: "Basic Salary" },
    { key: "HRA", label: "HRA - House Rent Allowance" },
    { key: "ConvAllow", label: "Conveyance Allowance" },
    { key: "Incentive", label: "Incentive" },
    { key: "OtherEarn", label: "Other Earning" },
    { key: "EpPF", label: "EPF - Employee Contribution" },
    { key: "ErPF", label: "EPF - Employer Contribution" },
    { key: "EmESIC", label: "ESIC - Employee Contribution" },
    { key: "ErESIC", label: "ESIC - Employer Contribution" },
    { key: "Health", label: "Health Insurance Amount" },
    { key: "Meal", label: "Meal Allowance Amount" },
    { key: "Transport", label: "Transport Allowance Amount" },
    { key: "TDS", label: "TDS - Tax Deducted at Source" },
    { key: "OtherDedu", label: "Other Deduction" },
    { key: "TP", label: "Total Present" },
    { key: "TA", label: "Total Absent" },
    { key: "BL", label: "Total Balance Leave (EL+CL)" },
    { key: "EN", label: "Leave Adjust Entitlement (How many leaves can adjust Absent)" },
    { key: "LOP", label: "Loss Of Pay Days after adjustment" },
    { key: "PD", label: "Paid  Days" },
    { key: "NetSalary", label: "Net Salary (Earning – Deductions)" },
    { key: "S", label: "Status" },
];

export default function PageInfo({ isOpen, onClose }: PageInfoProps) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalCloseButton />
                <ModalHeader fontWeight="600" fontSize="lg" textAlign={"center"}>Payroll List - Column Information</ModalHeader>

                <ModalBody>
                    <Box maxH="400px" overflowY="auto" border="1px solid #e2e8f0" borderRadius="8px" mb={4}>
                        <Table size="sm">
                            <Thead position="sticky" top={0} bg="gray.100" zIndex={1}>
                                <Tr>
                                    <Th>Column</Th>
                                    <Th>Description</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {columnInfo.map((c, i) => (
                                    <Tr key={i}>
                                        <Td fontWeight="500">{c.key}</Td>
                                        <Td>{c.label}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}
